import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "currentColor",
  viewBox: "0 0 767.6 809.9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M385.6 0c129.7 0 234.2 108.1 234.2 237.8 0 68.5-28.8 129.7-79.3 176.6 136.9 61.3 227 198.2 227 349.5 0 61.3-97.3 61.3-97.3 0 0-158.6-126.1-288.3-284.7-288.3S97.3 605.4 97.3 764c0 61.3-97.3 61.3-97.3 0 0-151.3 90.1-288.3 227-349.6-50.4-46.8-79.3-108.1-79.3-176.6C147.8 108.1 255.9 0 385.6 0zm0 97.3c-79.3 0-140.5 61.3-140.5 140.5 0 39.6 14.4 72.1 39.6 97.3 54.1 54.1 144.1 54.1 198.2 0 25.2-25.2 39.6-57.7 39.6-97.3 0-79.2-61.2-140.5-136.9-140.5z" }, null, -1)
  ])))
}
export default { render: render }